/* eslint-disable react/prop-types */
import { useController, useForm } from 'react-hook-form'
import StepHeading from '../../StepHeading'
import { TextField } from '@/components/ui/TextField'
import useSetupStore from '@/store/useSetupStore'
import { useEffect } from 'react'
import { ExclamationCircleIcon } from '@heroicons/react/16/solid'
import { isValid } from 'date-fns'
import Field from '@/components/ui/Field'
import { Input } from '@/components/ui/Input'
import { Label } from '@/components/ui/Label'
import FieldStatusMessage from '@/components/ui/FieldStatusMessage'
// import DatePicker from '@/components/ui/DatePicker'

export default function CreateVault({ form: _form }) {
  let form = useForm()

  form = _form
  const { errors } = form.formState

  const data = useSetupStore((state) => state.getData)()

  const { field } = useController({
    control: form.control,
    name: 'dateAsOf',
    rules: { required: 'The Date field is required.' },
    shouldUnregister: true,
    defaultValue: isValid(data?.dateAsOf) ? data?.dateAsOf : new Date(),
  })

  useEffect(() => {
    form.setValue('balance', data?.balance ?? '')
  }, [data, form])

  return (
    <div>
      <StepHeading>Create vault</StepHeading>
      <div className="grid grid-cols-2 gap-5">
        <div className="col-span-2">
          <Field
            status={errors?.name ? 'error' : ''}
            statusText={errors?.name?.message ?? null}
          >
            <Label>Name</Label>
            <Input
              {...form.register('name', {
                required: 'Name field is required',
                shouldUnregister: true,
              })}
            />
            <FieldStatusMessage />
          </Field>
        </div>
        <div>
          <TextField
            status={errors?.balance ? 'error' : ''}
            statusText={errors?.balance?.message ?? null}
          >
            <TextField.Label>Balance</TextField.Label>
            <TextField.Input
              placeholder="For example: 1000"
              {...form.register('balance', {
                required: 'The Balance field is required',
                shouldUnregister: true,
              })}
            />
          </TextField>
        </div>
        <div>
          <TextField
            status={errors?.dateAsOf ? 'error' : ''}
            statusText={errors?.dateAsOf?.message ?? null}
          >
            <TextField.Label>Date as of </TextField.Label>
            <TextField.DatePicker
              value={new Date(field.value)}
              selected={field.value}
              onSelect={field.onChange}
              placeholder="DD/MM/YYYY"
              className="w-full"
            />
          </TextField>
        </div>
      </div>
      <p className="mt-5 flex items-center gap-2 rounded-lg bg-gray-tr-08 p-2 text-sm text-txt-secondary">
        <ExclamationCircleIcon className="size-5" />
        <span>You can add more accounts when you complete the setup</span>
      </p>
    </div>
  )
}
